import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import ToggleFields from '../../components/ToggleFields';

const ShareSavings = ({ control, disabled, setValue }) => {
    const { t } = useTranslation();
    return (
        <ToggleFields
            control={control}
            defaultValue="shared_savings_saving_percentage"
            disabled={disabled}
            name="parameters[shared_savings_type]"
            setValue={setValue}
            values={{
                shared_savings_saving_percentage: {
                    append: '%',
                    label: t('Saving percentage'),
                    name: 'parameters[shared_savings_saving_percentage]',
                },
                shared_savings_target_irr: {
                    append: '%',
                    label: t('Target IRR'),
                    name: 'parameters[shared_savings_target_irr]',
                },
            }}
        />
    );
};

ShareSavings.propTypes = {
    control: PropTypes.object,
    disabled: PropTypes.bool,
    setValue: PropTypes.func,
};

export default ShareSavings;
